import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setSubmitted(true);
  };

  return (
    <div className="contact-page py-5">
      <Container>
        <Row className="align-items-center g-5">
          <Col md={6}>
            <h1 className="mb-3">Contact TechVahini</h1>
            <p className="text-muted mb-4">Have questions or suggestions? Send us a message and we’ll get back to you.</p>
            {submitted && <Alert variant="success">Thank you! Your message has been received.</Alert>}
            <Form onSubmit={onSubmit} noValidate>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control name="name" value={form.name} onChange={onChange} required placeholder="Your name" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={form.email} onChange={onChange} required placeholder="you@example.com" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="message">
                <Form.Label>Message</Form.Label>
                <Form.Control as="textarea" rows={5} name="message" value={form.message} onChange={onChange} required placeholder="Write your message here..." />
              </Form.Group>
              <Button type="submit" variant="primary">Send Message</Button>
            </Form>
          </Col>
          <Col md={6}>
            <div className="contact-card p-4 rounded">
              <h5>Reach us</h5>
              <p className="mb-1"><strong>Email:</strong> support@techvahini.com</p>
              <p className="mb-1"><strong>YouTube:</strong> youtube.com/@TechVahini</p>
              <p className="mb-1"><strong>Language:</strong> Marathi</p>
              <p className="mb-0"><strong>Content:</strong> Online Earning, Freelancing, Marketing</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
